var plugin_default = {
  "alignLeft": "yRTkY",
  "textWrapNowrap": "V3Qgx",
  "alignRight": "Y1mhV",
  "alignCenter": "sM02k",
  "sizeFullWidth": "MHa6w",
  "renderedInTable": "_125-7",
  "sizeOriginal": "_4MzLD",
  "sizeContent": "_54n3g",
  "sizeSmall": "UjTuA",
  "sizeSmallCenter": "o5fJX",
  "flex": "QZQfB",
  "atomic": "u686o",
  "embed": "LEFfD",
  "horizontalScrollbar": "dQ7cy",
  "pluginContainerMobile": "g4Ic6"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
